<template>
  <div class="home-box">
    <div v-if="background_pic" class="home-bg"></div>
    <div v-else class="home-bg" id="indexMap">
      <div class="map_gai_s"></div>
      <div class="map_gai_r"></div>
      <div class="map_gai_b"></div>
      <div class="map_gai_l"></div>
      <el-amap
        ref="map"
        vid="indexDemo"
        :center="center"
        :zoom="zoom"
        :amap-manager="amapManager"
        :events="mapEvents"
        class="index-demo"
      >
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="
            require('../../assets/home_images/new_point' + marker.ste + '.png')
          "
          :offset="[-25, -30]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.title"
        >
        </el-amap-marker>
        <el-amap-info-window
          isCustom="true"
          :position="currentWindow.position"
          :visible="currentWindow.visible"
          :events="{ close: () => closeWin() }"
          closeWhenClickMap="true"
        >
          <div class="item_map">
            <div class="close-window" @click="closeWin()">
              <i class="el-icon-close"></i>
            </div>
            <h3 class="info-title" :title="lampInfo.name">
              {{ lampInfo.name }}
            </h3>
            <div class="info-content">
              <div v-html="getGasValue(lampInfo.sb)"></div>
            </div>
            <div class="info-controls">
              <div class="botton-one" @click="backLightList(lampInfo.lamp_id)">
                <div class="icon">
                  <svg-icon name="lamp-control"/>
                </div>
                <div class="text">路灯控制</div>
              </div>
              <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
                <div class="icon">
                  <svg-icon name="video-preview"/>
                </div>
                <div class="text">摄像头</div>
              </div>
            </div>
          </div>
        </el-amap-info-window>
      </el-amap>
    </div>
    <div class="head">
      <div class="head-bg">
        <h1 v-if="$store.state.user.logo"><img :src="$store.state.user.logo" />{{$store.state.user.title}}</h1>
        <h1 v-else>{{$store.state.user.title}}</h1>
      </div>
    </div>
    <div class="head_bar_left">
      <img :src="require('../../assets/home_images/weather/myicon/' + weatherData.wea_img +'.png')" class="wea_icon"/>
      <span class="wea_text">{{weatherData.wea}}</span>
      <span>{{weatherData.tem_night}}℃～{{weatherData.tem_day}}℃</span>
      <span>{{weatherData.win}}{{weatherData.win_speed}}</span>
      <img src="@/assets/home_images/head_point.png" class="point" />
      <span class="city">{{weatherData.city}}</span>
    </div>
    <div class="head_bar_right">
      <span>{{nowDate.year}}.{{nowDate.month}}.{{nowDate.day}} </span>
      <span>{{nowDate.week}}</span>
      <span>{{nowDate.hour}}:{{nowDate.minute}}:{{nowDate.second}}</span>
    </div>
    <div class="go-system" @click="$router.push('/gis')">
      进入系统 <span>></span>
    </div>
    <div class="home-left">
      <div class="home_pad">
        <div class="main-left-top"><box1 :itemData="resData.lamp" :camera="resData.camera.all_number" :ip="resData.ip.total" :alarm="resData.one_key.total"></box1></div>
        <div class="main-left-cen">
          <box2 :itemData="resData.camera"></box2>
        </div>
        <div class="main-left-bot"><box3 :itemData="resData.ip"></box3></div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-right-top"><box4 :itemData="resData.env" :lamp_name="resData.lamp.name"></box4></div>
        <div class="main-right-cen">
          <box6 :itemData="resData.screen"></box6>
        </div>
        <div class="main-right-bot">
          <box7 :itemData="resData.alarm"></box7>
        </div>
      </div>
    </div>

    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看路灯监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import homeApi from "@/api/home/index";
import lightListApi from "@/api/light/lightList";
import cameraApi from "@/api/light/camera";
import box1 from "@/components/home/box1.vue";
import box2 from "@/components/home/box2.vue";
import box3 from "@/components/home/box3.vue";
import box4 from "@/components/home/box4.vue";
import box5 from "@/components/home/box5.vue";
import box6 from "@/components/home/box6.vue";
import box7 from "@/components/home/box7.vue";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import store from "@/store";
import { AMapManager } from "vue-amap";
import VueAMap from "vue-amap";
let amapManager = new VueAMap.AMapManager();
export default {
  components: {
    box1,
    box2,
    box3,
    box4,
    box5,
    box6,
    box7,
    videoBox,
    videoControl
  },
  data() {
    return {
      background_pic: store.state.user.userData.screen_background_image||'',
      resData: {
        lamp: {
          total: 0,
          online: 0,
          malfunction: 0,
          lamp_light: 0,
          light: 1,
          voltage: 220,
          current: 1,
          power: 220,
          lamp_id: 2,
          colorTemperature: 25,
          cost_electricity: 100,
          total_electricity: 2645.5,
          save_electricity: 2568.06,
          name: '默认灯杆',
          Power_factor: 0.0000039
        },
        camera: {
          number:'',
          channel: 1,
          all_number: 0,
          online_number: 0
        },
        env: [],
        ip: {
          total: 0,
          online: 0,
          Offline: 0
        },
        manhole: {
          total: 0,
          online: 0,
          Offline: 0,
          warning: 0
        },
        one_key: {
          total: 0,
          online: 0,
          Offline: 0
        },
        screen: {
          total: 0,
          program: 0,
          url: []
        },
        alarm: []
      },
      boxd: {
        id: 1,
        value: 2,
      },
      amapManager,
      mapEvents: {
        init(o) {
          o.setMapStyle("amap://styles/darkblue"); //自定义的高德地图的样式，我选的是马卡龙
        },
      },
      zoom: 16,
      center: store.state.user.account.center,
      currentWindow: {
        position: store.state.user.account.center,
        visible: false,
      },
      markers: [],
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      accessToken: '',
      weatherData: {
        wea_img: "qing",
        wea: "晴",
        tem_night: "9",
        tem_day: "20",
        win: "西风",
        win_speed: "2级",
        city: ""
      },
      nowDate: {
        year: '',
        month: '',
        day: '',
        week: '',
        hour: '',
        minute: '',
        second: '',
      },
      timer: null,
      timer2: null,
      timer3: null
    };
  },
  methods: {
    init: function () {
      //地图初始化
      map = new AMap.Map("indexMap", {
        resizeEnable: true,
      });
    },
    getData() {
      //获得首页数据
      homeApi.newHomeData().then((res) => {
        if (res.data.code === 1000) {
          this.resData = res.data.data;
        }
      });
    },

    getLampList() {
      //获得地图标记
      lightListApi
        .lightList({
          page: 1,
          pageSize: 100,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            this.markers = res.data.data.list;

            // const resData = res.data.data.list
            // const newarr = []
            // for(let i=1; i<resData.length; i++ ){
            //   if(resData[i].longitude&&resData[i].latitude){
            //     newarr[i]= resData[i]
            //   }
            // }
            // this.markers = newarr
        
            // this.$refs.map.$$getInstance().setFitView()
            if(this.$store.state.user.is_supper){
              this.zoom=8
            }
          }
        });
    },

    markerClick(marker) {
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
      setTimeout(function () {
        this.center = [Number(marker.longitude), Number(marker.latitude)];
      }, 200);
    },
    closeWin() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    getGasValue(items) {
      let gas_data = [
        "北风",
        "东北风",
        "东风",
        "东南风",
        "南风",
        "西南风",
        "西风",
        "西北风",
      ];
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    getNowTemp() {
      const that = this
      const url = 'https://weather.qyltd.com/free/day/index.php?appid=31736539&appsecret=mcKVlC8B&unescape=1'
      axios({
        method: 'get',
        url: url
      }).then(function(res) {
        if(res&&res.data.code===1000){
          that.weatherData = res.data.data
        }
      })
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; //月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = [ "星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六" ];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零
      this.nowDate = {
        year: year,
        month: month,
        day: day,
        week: weekArr[week],
        hour: hour,
        minute: minute,
        second: second
      }
    },
    backLightList(){
      this.$router.push({
        name: 'lightList',
        path:"/light/lightList"
      })
    }
  },
  mounted() {
    this.getLampList();
    // 下面为制作定时器（首页模块数据）
    this.getData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.getData(), 0);
      }, 6 * 1000);
    }

    // 下面为制作定时器（倒计时）
    this.formatDate();
    if (this.timer2) {
      clearInterval(this.timer2);
    } else {
      this.timer2 = setInterval(() => {
        setTimeout(this.formatDate(), 0);
      }, 500);
    }

    // 下面为制作定时器（天气预报）
    this.getNowTemp()
    if (this.timer3) {
      clearInterval(this.timer3)
    } else {
      this.timer3 = setInterval(() => {
        setTimeout(this.getNowTemp(), 0)
      }, 60 * 1000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null

    clearInterval(this.timer2)
    this.timer2 = null

    clearInterval(this.timer3)
    this.timer3 = null
    
  }
};
</script>
<style lang='less'>
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #01162b;
  .head {
    position: absolute;
    height: 76px;
    left: 30px;
    right: 30px;
    top: 0;
    z-index: 999;
    background: url("../../assets/home_images/head_bg.png") center bottom no-repeat;
    .head-bg {
      height: 76px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    h1 {
      font-size: 34px;
      color: #fff;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0;
      img{
        margin-right: 10px;
        height:50px;
      }
    }
  }

  .head_bar_left{
    position: absolute;
    right:50%;
    margin-right:400px;
    z-index: 1000;
    top:60px;
    display: none;
    align-items: center;
    justify-content: flex-start;
    img.wea_icon{
      width:auto;
      height:24px;
      margin-top:-2px;
    }
    img.point{
      width:auto;
      height:22px;
      margin-left:60px;
    }
    span{
      margin-left: 20px;
      color:#fff;
      font-size:14px;
      font-family: Bahnschrift, Arial, sans-serif;
    }
    .wea_text{
      margin-left: 4px;
    }
    .city{
      margin-left:2px;
    } 
  }

  .head_bar_right{
    position: absolute;
    left:50%;
    margin-left:380px;
    z-index: 1000;
    top:60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    span{
      margin-right: 30px;
      color:#fff;
      font-size:14px;
      font-family: Bahnschrift, Arial, sans-serif;
    }
  }

  .go-system {
    position: absolute;
    right: 70px;
    top: 58px;
    z-index: 1000;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size:18px;
    color:#fff;
    span {
      font-family: simsun;
      margin-left: 10px;
    }
  }
  .home-left {
    position: absolute;
    width: 460px;
    min-width: 420px;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 90px;
      padding-left: 30px;
      padding-bottom: 10px;
      position: relative;
      overflow: hidden;
      .main-left-top {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-cen {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-bot {
        padding: 15px 0;
        height: 26%;
        box-sizing: border-box;
        overflow: hidden;
      }
    }
  }
  .home-right {
    position: absolute;
    width: 460px;
    min-width: 420px;
    height: 100%;
    right: 0;
    top: 0;
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 90px;
      padding-right: 30px;
      padding-bottom: 10px;
      position: relative;
      overflow-y: hidden;
      .main-right-top {
        padding: 15px 0;
        height: 37%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-right-cen {
        padding: 15px 0;
        height: 30%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-right-bot {
        padding: 15px 0;
        height: 33%;
        box-sizing: border-box;
        overflow: hidden;
      }
    }
  }

  .home-bg {
    position: absolute;
    top:70px;
    left:350px;
    right:350px;
    bottom:0px;
    overflow: hidden;
    background: none;
    .map_gai_s{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      top:0;
      background-position: 0 0;
      background-repeat: repeat-x;
      background-image: url(../../assets/home_images/map_gai_s.png);
      z-index: 2;
    }
    .map_gai_r{
      width:250px;
      height:100%;
      position: absolute;
      right:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_r.png);
      background-position: repeat-y;
      z-index: 2;
    }
    .map_gai_b{
      width:100%;
      height:177px;
      position: absolute;
      left:0;
      bottom:0;
      background-size: auto 100%;
      background-image: url(../../assets/home_images/map_gai_b.png);
      background-position: repeat-x;
      z-index: 2;
    }
    
    .map_gai_l{
      width:250px;
      height:100%;
      position: absolute;
      left:0;
      bottom:0;
      top:0;
      background-size: 100% auto;
      background-image: url(../../assets/home_images/map_gai_l.png);
      z-index: 2;
      background-position: repeat-y;
    }
  }

  .index-demo {
    position: absolute;
    width:100%;
    height:100%;
    overflow: hidden;
    z-index: 1;
  }

  .amap-logo {
    display: none !important;
    opacity: 0 !important;
  }
  .amap-layers {
    background: #09152a !important;
  }

  .item_map {
    background-image: url("../../assets/home_images/item_map.png");
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 20px;
    border-radius: 20px;
    border: 2px solid #e8c255;
    position: relative;
    min-width: 200px;
    box-sizing: border-box;
    color: #fff;
    .close-window {
      width: 26px;
      height: 26px;
      border-radius: 26px;
      cursor: pointer;
      background: #413c33;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      z-index: 99999;
      i {
        color: #fff;
        font-size: 18px;
      }
    }
    .close-window:hover {
      background: #332d24;
    }
    h3.info-title {
      margin: 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 18px;
    }
    .info-content {
      margin: 5px 0;
      overflow: hidden;
    }
    .info-content span {
      width: 150px;
      float: left;
    }
    .info-controls {
      padding:5px 10px 10px;
      display: flex;
      align-items: center;
      .botton-one{
        margin-right: 20px;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .icon{
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          background-color: #715f2a;
          color:#fff;
        }
        .text{
          padding: 5px 0;
          font-size: 14px;
          text-align: center;
          color:#fff;
        }
        &:hover{
          .icon{
            border: 1px solid rgba(255, 255, 255, 1);
            color:#fff;
            background-color: #8b7533;
          }
          .text{
            color:#8b7533;
          }
        }
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .item_map:after {
    position: absolute;
    content: "";
    z-index: -1;
    bottom: -8px;
    left: 50%;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #e8c255;
  }

  @media screen and (max-width: 1440px){
    .head_bar_left{
      margin-right:340px;
      img.point{
        margin-left:40px;
      }

    }
    .head_bar_right{
      margin-left:340px;
    }
    .go-system {
      right: 40px;
    }
  }
}
.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}
</style>